import { types } from 'mobx-state-tree';
import { castCheckedEventToValue } from 'js/services/FormTools';

export default types
  .model('EmailPreference', {
    is_receiving: types.boolean,
    label: types.string,
    name: types.string,
  })
  .actions(self => ({
    setIsReceiving(isReceiving) {
      self.is_receiving = castCheckedEventToValue(isReceiving);
      return self;
    },
  }));
